import { useState } from "react";
import { Alert, Box, Button, Card, Typography } from "@mui/material";
import HourglassTopRoundedIcon from "@mui/icons-material/HourglassTopRounded";
import { useSession } from "../context/SessionContext";

/** Shown to someone who has signed up and confirmed their email but has no role yet. */
export default function PendingApprovalPage() {
  const { authUser, checkApproval, logout } = useSession();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  async function check() {
    setBusy(true);
    setMessage("");
    const user = await checkApproval();
    setBusy(false);
    if (!user) setMessage("Your session has ended. Please sign in again.");
    else if ((user.groups || []).length === 0) setMessage("Not approved yet. We will let you in as soon as an administrator approves your account.");
    // When approved, the session now has a role and the app opens by itself.
  }

  return (
    <Box
      sx={{
        minHeight: "100vh", display: "grid", placeItems: "center", p: 2,
        background:
          "radial-gradient(900px 500px at 15% 10%, rgba(99,102,241,0.55), transparent 60%)," +
          "radial-gradient(800px 500px at 90% 90%, rgba(14,165,233,0.45), transparent 60%)," +
          "linear-gradient(180deg, #0B1020, #141233)",
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 460, p: 4, borderRadius: 5, textAlign: "center" }}>
        <Box
          sx={{
            width: 64, height: 64, borderRadius: "50%", mx: "auto", mb: 2, display: "grid", placeItems: "center",
            color: "#4F46E5", backgroundColor: "rgba(99,102,241,0.12)",
          }}
        >
          <HourglassTopRoundedIcon fontSize="large" />
        </Box>
        <Typography variant="h5" sx={{ mb: 1 }}>Waiting for approval</Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          Your account <strong>{authUser?.email}</strong> is created and verified. An administrator needs to approve it and give you a role
          before you can see anything. You will not need to sign up again.
        </Typography>
        {message && <Alert severity="info" sx={{ mb: 2, textAlign: "left" }}>{message}</Alert>}
        <Box sx={{ display: "grid", gap: 1.5 }}>
          <Button variant="contained" size="large" onClick={check} disabled={busy}>
            {busy ? "Checking…" : "Check again"}
          </Button>
          <Button onClick={logout}>Sign out</Button>
        </Box>
      </Card>
    </Box>
  );
}
